import { useCallback } from 'react'
import ApiService from '../../services/ApiService'
import { showAlert } from '../../utility/SweetAlert'

const InteractorCompanyUpdate = () => {
  const companyUpdate = useCallback((payload) => {
    ApiService.jsonRequest('/account-company/update', payload, (response) => {
      if (response.status_code === 200) {
        showAlert({
          icon: 'success',
          message: 'Sukses Memperbarui Data',
          timer: 3000,
          reload: true,
        })
      } else {
        showAlert({
          icon: 'error',
          message: 'Gagal Memperbarui Data',
          timer: 3000,
          reload: false,
        })
      }
    })
  }, [])
  return { companyUpdate }
}

export default InteractorCompanyUpdate
